<template>
    <div class="base-flex">
        <el-button round @click="handleConnect" size="small">添加连接</el-button>
        <el-dialog title="连接" :visible.sync="dialogVisible" width="40%">
            <el-form ref="form" :model="form" label-width="100px">
                <el-form-item label="连接名称">
                    <el-input v-model="form.name" size="small"></el-input>
                </el-form-item>
                <el-form-item label="主机ip或名称">
                    <el-input v-model="form.host" size="small"></el-input>
                </el-form-item>
                <el-form-item label="端口">
                    <el-input v-model="form.port" size="small"></el-input>
                </el-form-item>
                <el-form-item label="用户名">
                    <el-input v-model="form.user" size="small"></el-input>
                </el-form-item>
                <el-form-item label="密码">
                    <el-input v-model="form.password" type="password" size="small"></el-input>
                </el-form-item>
                <el-form-item label="数据库类型">
                    <span  size="small">{{form.dialect}}</span>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleConfirm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import {createConnection} from "@/api/database/database.js"
export default {
    name: "Tools",
    data() {
        return {
            dialogVisible: false,
            form: {
                name: "本地",
                host: "localhost",
                port: "3306",
                user: "root",
                password: "root",
                dialect:"mysql",
            }
        }
    },
    methods: {
        handleConnect() {
            this.dialogVisible = true;
        },
        handleConfirm(){
           
            createConnection(this.form).then(v=>{
                console.log(v)
            })
        }
    }

}
</script>


// WEBPACK FOOTER //
// src/components/Tools/index.vue